// extracted by mini-css-extract-plugin
export default {"orderItemSummary":"G0b7014"};